// extracted by mini-css-extract-plugin
export default {"p":"_36911809a2 _8bb0f577e3 _787547b4d1","clr":"_58b9031600","dls":"_85d350abf5"};